'use client';

import { LazyLottie } from './LazyLottie';
import { IAnimationProps } from './types';

export function AssessmentInitiationAnimation(props: IAnimationProps) {
  const loadAnimation = () =>
    import('./raw-json/assessment-initiation-animation.json');

  return (
    <LazyLottie
      {...props}
      getAnimationData={loadAnimation}
      id="AssessmentInitiationAnimation"
    />
  );
}
